import _regeneratorRuntime from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import axios from "axios";
import { getApiHeader } from "./token";
export var getInstitution = function getInstitution(id) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get("api/institutions/".concat(id), getApiHeader());

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
export var getAllInstitutionCodes = function getAllInstitutionCodes() {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios.get("api/institutions/all-codes", getApiHeader());

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};
export var create = function create(institution) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios.post("api/institutions", institution, getApiHeader());

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
export var setAddresses = function setAddresses(id, addresses) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return axios.put("api/institutions/".concat(id, "/addresses"), addresses, getApiHeader());

          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};
export var setPhones = function setPhones(id, phones) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axios.put("api/institutions/".concat(id, "/phones"), phones, getApiHeader());

          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
};
export var addPhysician = function addPhysician(institutionId, physicianId) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return axios.post("api/institutions/".concat(institutionId, "/physicians"), {
              institutionId: institutionId,
              physicianId: physicianId
            }, getApiHeader());

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
};
export default {
  create: create,
  getInstitution: getInstitution,
  getAllInstitutionCodes: getAllInstitutionCodes,
  setAddresses: setAddresses,
  setPhones: setPhones,
  addPhysician: addPhysician
};